<template>
  <div style="padding-top: 1.5rem">
    <HomeHeaderView :usr="usr" @usrInf="getusrInf" />
    <div
      id="home_box"
      style="
        height: calc(100vh - 2rem);
        height: calc(100dvh - 2rem);
        overflow-y: auto;
        width: 100%;
      "
      @scroll="handleScroll"
    >
      <HomeBannerView />
      <HomeGridView :usr="usr" />
      <GameBoxView />
      <FriendLinkView />
    </div>
    <div class="flex-btn kefu" @click="openNativePage()">
      <svg-icon
        icon-class="kefu"
        style="width: 30px !important; height: 30px !important"
      />
      <p>在线客服</p>
    </div>
    <div @click="scrollToTop" v-if="showButton" class="flex-btn top">
      <svg-icon
        icon-class="top"
        style="width: 25px !important; height: 25px !important"
      />
      <p>TOP</p>
    </div>
  </div>
</template>

<script>
import {
  HomeHeaderView,
  HomeBannerView,
  HomeGridView,
  GameBoxView,
  FriendLinkView
} from './components/index'
export default {
  name: 'HomeView',
  components: {
    HomeHeaderView,
    HomeBannerView,
    HomeGridView,
    GameBoxView,
    FriendLinkView
  },
  data () {
    return {
      usr: null,
      showButton:false
    }
  },
  mounted(){
    this.getusrInf()
  },
  methods: {
    async getusrInf () {
      await this.$http({
        method: 'post',
        url: 'usrInf'
      }).then(data => {
        this.usr = data.data
      })
    },
    handleScroll () {
      this.showButton = document.getElementById('home_box').scrollTop > 10 // 滚动超过200px显示按钮
    },
    scrollToTop () {
      document
        .getElementById('home_box')
        .scrollTo({ top: 0, behavior: 'smooth' }) // 平滑滚动到顶部
    },
    checkDevice () {
      const u = navigator.userAgent
      return {
        isAndroid: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      }
    },
    isIOS () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    },
    callAndroidMethod (method, params) {
      if (window.Android && typeof window.Android[method] === 'function') {
        window.Android[method](JSON.stringify(params))
      } else {
        this.$toast.fail('Android方法未注入')
      }
    },
    callIOSMethod (method, params) {
      if (window.webkit && window.webkit.messageHandlers[method]) {
        window.webkit.messageHandlers[method].postMessage(
          JSON.stringify(params)
        )
      } else {
       this.$toast.fail('iOS方法未注入')
      }
    },
    openNativePage () {
      const device = this.checkDevice()
      if (device.isAndroid) {
        // this.callAndroidMethod('toKeFu', { page: 'toKeFu' })
        let targetUserId = '1'; 
        let apiObjectName = '_dsbridge';
        if (window[apiObjectName] && window[apiObjectName].toKefu) {
          window[apiObjectName].toKefu(targetUserId); 
        } else {
          this.$toast.fail('Android方法未注入')
        }

      } else if (this.isIOS()) {
        if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openBrowser){
          try {
            window.webkit.messageHandlers.openBrowser.postMessage('tokefu');
          } catch (error) {
            this.$toast.fail('IOS方法调用失败')
          }
        } else {
          this.$toast.fail('IOS方法未注入')
        }
        
        
        //this.callIOSMethod('toKeFu', { page: '' })
      } else {
        this.$router.push({ name: 'news'});
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-page {
}
.flex-btn {
  position: fixed;
  z-index: 999;
  right: 20px;
  color: #fff;
  background: rgb(0, 0, 0, 0.7);
  border-radius: 10px;
  text-align: center;
  font-size: 12px;
  width: 50px;

  padding: 8px;
  p {
    line-height: 0.8;
  }
}
.kefu {
  bottom: 100px;
  height: 40px;
}
.top {
  bottom: 20px;
  padding-top: 10px;
  height: 35px;
}
</style>
